import { render, staticRenderFns } from "./CollectiveNotFound.vue?vue&type=template&id=6b3e73bf&scoped=true"
import script from "./CollectiveNotFound.vue?vue&type=script&lang=js"
export * from "./CollectiveNotFound.vue?vue&type=script&lang=js"
import style0 from "./CollectiveNotFound.vue?vue&type=style&index=0&id=6b3e73bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e73bf",
  null
  
)

export default component.exports